"use client";
import "@/styles/carousel-base.css";
import ImageUI from "../CustomImage/ImageUI";
import { Widget } from "@pulsex/types";
import Link from "next/link";

 export default function CoverageSide({ widget }: { widget: Widget | null }) {
    if(!widget?.posts[0]) return;
    const coverage = widget?.posts[0];
    return (
        <div className="flex-1">
            <div className="sticky top-24 mt-6">
                <Link href={coverage?.url}className="block text-xl font-bold mb-3 dark:text-white">
                    {widget?.title}
                </Link>
                <div className="relative overflow-hidden rounded-lg">
                    <Link href={coverage?.url}>
                        <ImageUI
                            data={coverage}
                            cropSize={"rectangle"}
                        />
                    </Link>
                </div>
            </div>
        </div>
    );
}
